import { getLanguageTag, getOrderId, ocapiClient, registerOrderAction } from '@vista/omnichannel-components-domain';
import { PaymentClient } from '@vista-digital/embedded-payments';
import { OrderPaymentFormEmbeddedPaymentConnectorActionType as ActionType } from './embedded-payment-connector-action-type';
export const createPaymentClient = (props) => {
    const { paymentMethodId, containerRef, childContainerClassName, redirectReturnUrl, onPaymentSuccessful, onPaymentFailed, dispatch } = props;
    const orderId = getOrderId();
    if (!orderId)
        throw new Error('Cannot create PaymentClient without an order ID.');
    if (!containerRef.current)
        throw new Error('Cannot create PaymentClient without a container element.');
    let deregisterAction;
    return new PaymentClient({
        orderId: orderId,
        webPaymentMethodId: paymentMethodId,
        container: containerRef.current,
        childContainerClassName: childContainerClassName,
        ocapiClient: ocapiClient.instance,
        redirectReturnUrl: redirectReturnUrl || window.location.href,
        languageTag: getLanguageTag(),
        events: {
            onPaymentStarted: () => {
                deregisterAction = registerOrderAction('order-payment-form');
                dispatch({ type: ActionType.PaymentStarting });
            },
            onPaymentSuccessful: (orderCompletion) => {
                if (deregisterAction)
                    deregisterAction();
                onPaymentSuccessful(orderCompletion);
                // Do not dispatch any changes, as the connector component will be unmounted
            },
            onPaymentFailed: (error) => {
                if (deregisterAction)
                    deregisterAction();
                onPaymentFailed(error);
                // Do not dispatch any changes, as the connector component will be unmounted
            },
            onPaymentButtonStateChanged: (paymentButtonState) => {
                dispatch({ type: ActionType.PaymentButtonStateChanged, paymentButtonState });
            }
        }
    });
};
